import { MOUNT_POINTS, SELECTORS, } from 'config/preRenderedSelectorsConfig';
import { classList, node, addElementAfter, createElement, } from 'utils/dom';


const { POST_CONTENT_SELECTOR, } = SELECTORS;
const INJECTION_CONF = {
  INSERT_AFTER_ELEMENTS_COUNT: 2,
  ELEMENTS_TO_COUNT_TAGNAME: 'p',
  CLASS_NAME: MOUNT_POINTS.YAHOO_FANTASY_MOUNT_POINT.slice(1),
  TAG_NAME: 'div',
};


function filterRelevantParagraphs(CONTENT_NODE_SELECTOR, elementsTagName){
  const contentNode = node(CONTENT_NODE_SELECTOR);
  if (!contentNode) {
    return null;
  }
  return Array
    .from(contentNode.children)
    .filter(element => {
      const doesElementMatch = element.matches ?
        element.matches(elementsTagName) :
        element.tagName.toLowerCase() === elementsTagName;
      return doesElementMatch && element.innerText && element.children.length === 0;
    });
}

export function injectFantasyInsideArticle(){
  const {
    TAG_NAME,
    CLASS_NAME,
    ELEMENTS_TO_COUNT_TAGNAME,
    INSERT_AFTER_ELEMENTS_COUNT,
  } = INJECTION_CONF;
  const injectedEl = createElement(TAG_NAME);
  classList(injectedEl).add(CLASS_NAME);
  const paragraphs = filterRelevantParagraphs(POST_CONTENT_SELECTOR, ELEMENTS_TO_COUNT_TAGNAME);
  if (paragraphs && paragraphs.length > INSERT_AFTER_ELEMENTS_COUNT){
    return addElementAfter(injectedEl, paragraphs[INSERT_AFTER_ELEMENTS_COUNT - 1]);
  }
  node(POST_CONTENT_SELECTOR).appendChild(injectedEl);
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/fantasyNodeInjector.js